import { z } from 'zod'
import { codePointLength, trimForValidate } from '@/utils/stringLength'

export function trimmedString(opts: {
  min?: number
  max: number
  label: string
  required?: boolean
}) {
  return z
    .string()
    .superRefine((raw, ctx) => {
      const v = trimForValidate(raw)
      if (opts.required !== false && v.length === 0) {
        ctx.addIssue({ code: 'custom', message: `请输入${opts.label}` })
        return
      }
      if (v.length === 0) return

      const len = codePointLength(v)
      if (opts.min != null && len < opts.min) {
        ctx.addIssue({ code: 'custom', message: `${opts.label}至少 ${opts.min} 个字符` })
      }
      if (len > opts.max) {
        ctx.addIssue({ code: 'custom', message: `${opts.label}不能超过 ${opts.max} 个字符` })
      }
    })
    .transform(trimForValidate)
}
